import React from 'react';
import { Route } from 'react-router-dom';
import TenantManagement from '@/pages/superadmin/TenantManagement';
import SubscriptionManagement from '@/pages/superadmin/SubscriptionManagement';
import SubscriptionDashboard from '@/pages/superadmin/SubscriptionDashboard';
import SubscriptionPlans from '@/pages/superadmin/SubscriptionPlans';
import PaymentGatewaySettings from '@/pages/superadmin/PaymentGatewaySettings';
import GroupManagement from '@/pages/superadmin/GroupManagement';
import DataMigration from '@/pages/superadmin/DataMigration';
import TicketManagement from '@/pages/superadmin/TicketManagement';
import CombinedSubscriptionDashboard from '@/pages/superadmin/CombinedSubscriptionDashboard';
import PaymentRequestsManagement from '@/pages/superadmin/PaymentRequestsManagement';
import EmailSettings from '@/pages/superadmin/EmailSettings';
import WhatsAppSettings from '@/pages/superadmin/WhatsAppSettings';
import DeleteLogs from '@/pages/audit/DeleteLogs';
import SubscriptionDiscountReport from '@/pages/superadmin/SubscriptionDiscountReport';
import PublicPlanDiscounts from '@/pages/superadmin/PublicPlanDiscounts';
import TrialReport from '@/pages/superadmin/TrialReport';

export const superAdminRoutes = (
  <React.Fragment>
    <Route path="/superadmin/tenants" element={<TenantManagement />} />
    <Route path="/superadmin/groups" element={<GroupManagement />} />
    <Route path="/superadmin/subscriptions" element={<SubscriptionDashboard />} />
    <Route path="/superadmin/combined-subscriptions" element={<CombinedSubscriptionDashboard />} />
    <Route path="/superadmin/subscription-management" element={<SubscriptionManagement />} />
    <Route path="/superadmin/subscription-plans" element={<SubscriptionPlans />} />
    <Route path="/superadmin/payment-gateway" element={<PaymentGatewaySettings />} />
    <Route path="/superadmin/payment-requests" element={<PaymentRequestsManagement />} />
    <Route path="/superadmin/email-settings" element={<EmailSettings />} />
    <Route path="/superadmin/whatsapp-settings" element={<WhatsAppSettings />} />
    <Route path="/superadmin/data-migration" element={<DataMigration />} />
    <Route path="/superadmin/tickets" element={<TicketManagement />} />
    <Route path="/superadmin/delete-logs" element={<DeleteLogs />} />
    <Route path="/superadmin/subscription-discount-report" element={<SubscriptionDiscountReport />} />
    <Route path="/superadmin/public-plan-discounts" element={<PublicPlanDiscounts />} />
    <Route path="/superadmin/trial-report" element={<TrialReport />} />
  </React.Fragment>
);
